





















import { Component, Vue } from "vue-property-decorator";
import AccountingComponent from "../components/AccountingComponent.vue";
import emitter from "@/EventBus";
import AccountingSearchOptions from "@/ui/common/presenters/accounting-search-options";
import Estimate from "@/usecases/accounting/estimate";
import { client } from "@/api/request";
import { isNewProject } from "@/preferences";
import { PrintNewOrder } from "@/api/orders/print-api";
import EstimateContractDateModal from "@/ui/order/components/EstimateContractDateModal.vue";
import Status from "@/usecases/orders/estimate-status";
import {
  changeStatusAccouting,
  IStatusAccouting
} from "@/api/accounting/status-api";
import { StateChanger } from "vue-infinite-loading";

@Component({
  components: {
    AccountingComponent,
    EstimateContractDateModal
  },
  methods: {
    isNewProject
  }
})
export default class AccountingEstimate extends Vue {
  estimateSearch = {};
  estimateItems: Estimate[] = [];
  resetLoadInfinite = 0;
  estimateId: string = "";
  projectContractDate: string = "";
  isSearching: boolean = false;
  isPositionPrinting: number = -1;

  fields = [
    { key: "estimateNumber", label: "見積書No" },
    { key: "dateOfIssue", label: "発行日" },
    { key: "projectName", label: "現場" },
    { key: "title", label: "件名" },
    { key: "projectClientName", label: "発注元" },
    { key: "status", label: "ステータス" },
    { key: "total", label: "金額" },
    { key: "actions", label: "" }
  ];

  handleSearch($state: StateChanger) {
    this.estimateItems = [];
    $state.reset();
  }

  created() {
    emitter.on("initData", data => {
      this.estimateSearch = data as AccountingSearchOptions;
    });
  }

  currentOptions(currentLength: number, options?: { projectName: string }) {
    const new_options = {
      ...options,
      estimateCount: currentLength,
      getParentEstimate: true
    };

    return new_options;
  }

  async getEstimateList30(options?: any) {
    const new_options = this.currentOptions(this.estimateItems.length, options);
    const newEstimateItems = await client.get("get_estimate.php", new_options);

    return newEstimateItems;
  }

  async loadInfinite($state: any) {
    const loadedEstimateItems = await this.getEstimateList30(
      this.estimateSearch
    );

    if (loadedEstimateItems.estimates.length) {
      this.estimateItems = this.estimateItems.concat(
        loadedEstimateItems.estimates
      );
      $state.loaded();
    } else {
      $state.complete();
    }

    if (loadedEstimateItems.estimates.length < 30) {
      $state.complete();
      return;
    }
  }

  async changeStatus(item: any, status: string) {
    if (status === Status.Success && isNewProject(item.projectCreated)) {
      this.estimateId = item.id;
      this.projectContractDate = item.projectContractDate;
      (this.$refs.modalSetContractDate as any).show();

      return;
    }
    await this.handleChangeStatus(item, status);
  }

  async handleCreatePdf(item: any, index: number) {
    if (this.isPositionPrinting !== -1) {
      alert(
        "現在他の見積書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );

      return;
    }
    this.isPositionPrinting = index;
    let options: PrintNewOrder = {
      id: item.id,
      accessToken: this.$store.state.accessToken,
      printsExcludeTax: item.printsExcludeTax
    };

    if (isNewProject(item.projectCreated)) {
      options = {
        ...options,
        orderNew: 1
      };
    }

    try {
      const data = await client.get("create_estimate_pdf.php", options);
      window.open(data.pdf, "発注書印刷");
    } catch (error) {
      alert(error);
    } finally {
      this.isPositionPrinting = -1;
    }
  }

  async handleChangeStatus(item: any, status: string, contractDate?: any) {
    if (typeof item == "number") {
      item = this.getEstimateElement(item);
    }

    let option: IStatusAccouting = {
      id: item.id,
      projectId: item.projectId,
      status,
      model: "Estimate"
    };

    if (contractDate) {
      option = {
        ...option,
        contractDate
      };
    }
    try {
      const id = await changeStatusAccouting(option);
      this.updateEstimate(id, { status, contractDate });
      if (contractDate) {
        this.estimateItems.forEach(estimate => {
          if (
            estimate.projectId === item.projectId &&
            estimate.status == "success"
          ) {
            estimate.projectContractDate = contractDate;
          }
        });
      }
    } catch (error) {
      alert(error);
    }
  }

  updateEstimate(id: number, data: Record<string, string | number>) {
    const index = this.estimateItems.findIndex(item => item.id == id);
    if (index !== -1) {
      Vue.set(this.estimateItems, index, {
        ...this.estimateItems[index],
        ...data
      });
    }
  }

  getEstimateElement(id: number) {
    const index = this.estimateItems.findIndex(estimate => estimate.id == id);

    return this.estimateItems[index];
  }
}
